import { BaseService } from './BaseService';

export const EmpenhoSIAFService = {
    /**
     * Upload de arquivo SIAF para processamento
     * @param {FormData} formData - Arquivo e dados do formulário
     * @returns {Promise} Resposta da API
     */
    async uploadFile(formData) {
        try {
            const response = await BaseService.fetchResponseFromAPIPost('empenhos-siaf/upload', formData);
            return response;
        } catch (error) {
            console.error('Erro no upload do arquivo SIAF:', error);
            throw error;
        }
    },

    /**
     * Buscar lista de processamentos SIAF
     * @returns {Promise} Lista de processamentos
     */
    async getProcessamentos() {
        try {
            const response = await BaseService.fetchResponseFromAPIGet('empenhos-siaf/processamentos');
            return response;
        } catch (error) {
            console.error('Erro ao buscar processamentos SIAF:', error);
            throw error;
        }
    },

    /**
     * Reprocessar um item específico SIAF
     * @param {number} id - ID do processamento
     * @returns {Promise} Resposta da API
     */
    async retryProcessamento(id) {
        try {
            const response = await BaseService.fetchResponseFromAPIPost(`empenhos-siaf/processamentos/${id}/retry`, {});
            return response;
        } catch (error) {
            console.error('Erro ao reprocessar SIAF:', error);
            throw error;
        }
    },

    /**
     * Buscar detalhes de um processamento SIAF
     * @param {number} id - ID do processamento
     * @returns {Promise} Detalhes do processamento
     */
    async getProcessamentoById(id) {
        try {
            const response = await BaseService.fetchResponseFromAPIGet(`empenhos-siaf/processamentos/${id}`);
            return response;
        } catch (error) {
            console.error('Erro ao buscar processamento SIAF:', error);
            throw error;
        }
    },

    /**
     * Buscar logs de processamento SIAF
     * @param {number} id - ID do processamento
     * @returns {Promise} Logs do processamento
     */
    async getLogsProcessamento(id) {
        try {
            const response = await BaseService.fetchResponseFromAPIGet(`empenhos-siaf/processamentos/${id}/logs`);
            return response;
        } catch (error) {
            console.error('Erro ao buscar logs SIAF:', error);
            throw error;
        }
    },

    /**
     * Validar formato da planilha SIAF antes do upload
     * @param {File} file - Arquivo a ser validado
     * @returns {Promise} Resultado da validação
     */
    async validateFile(file) {
        try {
            const formData = new FormData();
            formData.append('file', file);
            
            const response = await BaseService.fetchResponseFromAPIPost('empenhos-siaf/validate', formData);
            return response;
        } catch (error) {
            console.error('Erro na validação do arquivo SIAF:', error);
            throw error;
        }
    },

    /**
     * Buscar estatísticas de processamento SIAF
     * @returns {Promise} Estatísticas
     */
    async getEstatisticas() {
        try {
            const response = await BaseService.fetchResponseFromAPIGet('empenhos-siaf/estatisticas');
            return response;
        } catch (error) {
            console.error('Erro ao buscar estatísticas SIAF:', error);
            throw error;
        }
    },

    /**
     * Listar empenhos SIAF paginados com filtros
     * @param {FormData} filter - Filtros de busca
     * @returns {Promise} Lista paginada de empenhos SIAF
     */
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('empenhos-siaf/search', filter);
        } catch (error) {
            console.error('Erro ao listar empenhos SIAF:', error);
            return false;
        }
    },

    /**
     * Buscar empenhos SIAF com filtros (alias para index)
     * @param {Object} filter - Filtros de busca
     * @returns {Promise} Lista de empenhos SIAF
     */
    async search(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('empenhos-siaf/search', filter);
        } catch (error) {
            console.error('Erro ao buscar empenhos SIAF:', error);
            return false;
        }
    },

    /**
     * Excluir empenhos SIAF
     * @param {Object} postData - Dados para exclusão
     * @returns {Promise} Resultado da exclusão
     */
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('empenhos-siaf/destroy', postData);
        } catch (error) {
            console.error('Erro ao excluir empenhos SIAF:', error);
            return false;
        }
    },

    /**
     * Buscar detalhes de um empenho SIAF específico
     * @param {number} id - ID do empenho
     * @returns {Promise} Detalhes do empenho
     */
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`empenhos-siaf/${id}`);
        } catch (error) {
            console.error('Erro ao buscar empenho SIAF:', error);
            return false;
        }
    },

    /**
     * Buscar histórico de um empenho SIAF
     * @param {number} id - ID do empenho
     * @returns {Promise} Histórico do empenho
     */
    async history(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`empenhos-siaf/historico/${id}`);
        } catch (error) {
            console.error('Erro ao buscar histórico SIAF:', error);
            return false;
        }
    },

    /**
     * Buscar transações de um empenho SIAF
     * @param {number} id - ID do empenho
     * @returns {Promise} Transações do empenho
     */
    async transacoes(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`empenhos-siaf/transacoes/${id}`);
        } catch (error) {
            console.error('Erro ao buscar transações do empenho SIAF:', error);
            return false;
        }
    }
};
